(function($) {
    $(window).load(function(){
        $activeAccordionItem = $('.accordion-item.deepable.is-active');
        $nav = $('.ct-component-meganavigation.show-for-medium.sticky');
        if ($activeAccordionItem !== false && $activeAccordionItem.offset() !== undefined) {
            $scrollTop = $activeAccordionItem.offset().top - 85;
            $('html, body').animate({ scrollTop: $scrollTop });
        }
    });

    $(window).load(function(){
        $(document).on( 'click', '.download-badge, .download-sub-category' , function(e) {
            e.preventDefault();
            window.location.href = $(this).data('href');
        });

        $(document).on( 'click', '.download-badge-filter' , function(e) {
            e.preventDefault();
            if ($(this).hasClass('filtered')) {
                $(this).removeClass('filtered');
                $('#search-results .box-entry').show();
            }
            else {
                $('.download-badge-filter').removeClass('filtered');
                $(this).addClass('filtered');
                $('#search-results .box-entry').hide();
                $('#search-results .box-entry.' + $(this).attr('href')).show();
            }
        });


        var thread = null;
        var dots = 0;

        function printDots() {
            if ($('#search-loading').is(':visible')) {
                if (dots < 3) {
                    $('#search-loading #dots').append('.');
                    dots++;
                } else {
                    $('#search-loading #dots').html('');
                    dots = 0;
                }
                setTimeout(function(){printDots();}, 500);
            }
        }

        function processSearch() {
            var searchbox = $('#download-form');
            var serviceUrl = searchbox.attr('action');
            var category = searchbox.find('input[name="category"]').val();
            var term = searchbox.find('input[name="term"]').val();
            var lang = searchbox.attr('language');

            if (term.length > 0) {
                $('.ct-download-top-posts').hide();
                $('.top-downloads-title').hide();
                $('.fachbereich-downloads-title').hide();
                $('.ct-download-container').hide();
                $('#search-results').hide();
                $('#search-noresults').hide();
                $('#search-loading').show();

                setTimeout(function () {
                    printDots();
                }, 500);

                var searchUrl = serviceUrl + '?category=' + encodeURIComponent(category) + '&lang=' + encodeURIComponent(lang) + '&term=' + encodeURIComponent(term);

                $.ajax({
                    type: 'GET',
                    url: searchUrl
                })
                    .done(function (result) {
                        var searchbox = $('#download-form');
                        var searchResults = $('#search-results');
                        var searchEntries = '';
                        var mainCategories = [];
                        searchResults.empty();
                        if (result && result.data.length) {
                            var itemTemplate = $('#item-template').clone();
                            itemTemplate.removeClass('search-template');
                            itemTemplate.attr('id', '');

                            var introTemplate = $('#search-resultsintro').clone();
                            introTemplate.removeClass('search-template');
                            introTemplate.attr('id', '');
                            introTemplate = introTemplate.html();
                            introTemplate = introTemplate.replace('%%searchterm%%', result.term);
                            searchResults.append(introTemplate);

                            $.each(result.data, function (key, value) {
                                var newItemTemplate = itemTemplate.clone().html();
                                newItemTemplate = newItemTemplate.replace('%%download.title%%', value.title);
                                newItemTemplate = newItemTemplate.replace('%%download.extension%%', value.extension);
                                newItemTemplate = newItemTemplate.replace('%%download.link%%', value.link);
                                if (value.infotext.length) {
                                    var infoTextTemplate = $('#infotext-template').clone();
                                    infoTextTemplate.removeClass('search-template');
                                    infoTextTemplate.attr('id', '');
                                    infoTextTemplate = infoTextTemplate.html();
                                    infoTextTemplate = infoTextTemplate.replace('%%download.infotext%%', value.infotext);
                                    newItemTemplate = newItemTemplate.replace('%%download.infotext%%', infoTextTemplate);
                                } else {
                                    newItemTemplate = newItemTemplate.replace('%%download.infotext%%', '');
                                }

                                var subCategoriesHtml = '';
                                if(value.categories.length > 0){
                                    var subCategoryTemplate = $('#sub-categories-item-template').clone();
                                    subCategoryTemplate.attr('id', '');
                                    $.each(value.categories, function(key, category){
                                        var newSubCategory = subCategoryTemplate.clone().html();
                                        newSubCategory = newSubCategory.replace('%%category.name%%', category.name);
                                        newSubCategory = newSubCategory.replace('%%category.hash%%', category.hash);
                                        subCategoriesHtml += newSubCategory;
                                    });
                                }
                               
                               
                                var baseUrl = searchbox.attr('baseurl');
                                if (value.maincategories.length && result.category === 0) {
                                    var categoriesTemplate = $('#categories-template').clone();
                                    categoriesTemplate.removeClass('search-template');
                                    categoriesTemplate.attr('id', '');
                                    categoriesTemplate = categoriesTemplate.html();

                                    var categoriesItemTemplate = $('#categories-item-template').clone();
                                    categoriesItemTemplate.removeClass('search-template');
                                    categoriesItemTemplate.attr('id', '');

                                    var items = '';
                                    var categoryClasses = '';
                                    $.each(value.maincategories, function (subkey, subvalue) {
                                        categoryClasses = categoryClasses + 'category-' + subvalue.id + ' ';
                                        mainCategories.push(subvalue.id);
                                        var newCategoriesItemTemplate = categoriesItemTemplate.clone().html();
                                        newCategoriesItemTemplate = newCategoriesItemTemplate.replace('%%category.textstyle%%', subvalue.textstyle);
                                        newCategoriesItemTemplate = newCategoriesItemTemplate.replace('%%category.backgroundcolor%%', subvalue.backgroundcolor);
                                        newCategoriesItemTemplate = newCategoriesItemTemplate.replace('%%category.name%%', subvalue.name);
                                        newCategoriesItemTemplate = newCategoriesItemTemplate.replace('%%sub-categories%%', subCategoriesHtml);
                                        newCategoriesItemTemplate = newCategoriesItemTemplate.replaceAll('%%category.link%%', baseUrl + '?category=' + subvalue.id);
                                        newCategoriesItemTemplate = newCategoriesItemTemplate.replace('data-style', 'style');
                                        items = items + newCategoriesItemTemplate;
                                    });
                                    categoriesTemplate = categoriesTemplate.replace('%%download.categories%%', items);
                                    newItemTemplate = newItemTemplate.replace('%%download.categories%%', categoriesTemplate);
                                    newItemTemplate = newItemTemplate.replace('%%category.classes%%', categoryClasses);
                                } else if(value.categories.length > 0){
                                    newItemTemplate = newItemTemplate.replace('%%download.categories%%', '<div class="sub-categories-container">' + subCategoriesHtml + '</div>');
                                    newItemTemplate = newItemTemplate.replaceAll('%%category.link%%', baseUrl + '?category=' + category);
                                    newItemTemplate = newItemTemplate.replace('%%category.classes%%', '');
                                } else {
                                    newItemTemplate = newItemTemplate.replace('%%download.categories%%', '');
                                    newItemTemplate = newItemTemplate.replace('%%category.classes%%', '');
                                }

                                searchEntries = searchEntries + newItemTemplate;
                            });

                            if (result.category === 0) {
                                var searchCatsTemplate = $('#search-resultscategories').clone();
                                searchCatsTemplate.removeClass('search-template');
                                searchCatsTemplate.attr('id', '');
                                searchCatsTemplate = searchCatsTemplate.html();

                                var searchCatsItemTemplate = $('#search-resultscategories-item').clone();
                                searchCatsItemTemplate.removeClass('search-template');
                                searchCatsItemTemplate.attr('id', '');
                                searchCatsItemTemplate = searchCatsItemTemplate;
                                searchCategories = '';

                                $.each(result.categories, function (key, value) {
                                    if ($.inArray(value.id, mainCategories) >= 0) {
                                        var newSearchCatsItemTemplate = searchCatsItemTemplate.clone().html();
                                        newSearchCatsItemTemplate = newSearchCatsItemTemplate.replace('%%category.id%%', 'category-' + value.id);
                                        newSearchCatsItemTemplate = newSearchCatsItemTemplate.replace('%%category.textstyle%%', value.textstyle);
                                        newSearchCatsItemTemplate = newSearchCatsItemTemplate.replace('%%category.backgroundcolor%%', value.backgroundcolor);
                                        newSearchCatsItemTemplate = newSearchCatsItemTemplate.replace('%%category.name%%', value.name);
                                        newSearchCatsItemTemplate = newSearchCatsItemTemplate.replace('data-style', 'style');
                                        searchCategories = searchCategories + newSearchCatsItemTemplate;
                                    }
                                });
                                if (searchCategories.length > 0) {
                                    searchCatsTemplate = searchCatsTemplate.replace('%%search.categories%%', searchCategories);
                                    searchResults.append(searchCatsTemplate);
                                }
                            }
                            searchResults.append(searchEntries);

                            $('#search-loading').hide();
                            $('#search-results').show();
                        } else {
                            $('#search-loading').hide();
                            $('#search-noresults').show();
                        }
                    });
            }
            else {
                // reset views
                $('.ct-download-top-posts').show();
                $('.top-downloads-title').show();
                $('.fachbereich-downloads-title').show();
                $('.ct-download-container').show();
                $('#search-loading').hide();
                $('#search-results').hide();
                $('#search-noresults').hide();
            }
        }

        var searchbox = $('#download-form');
        if (searchbox) {
            var searchValue = '';
            searchbox.on('submit', function(e) {
                e.preventDefault();
                searchValue = searchbox.find('input.searchinputfield').val().trim();
                processSearch();
            });
            searchbox.find('input.searchinputfield').keyup(function() {
                var newSearchValue = $(this).val().trim();
                if(newSearchValue !== searchValue){
                    searchValue = newSearchValue;
                    clearTimeout(thread);
                    thread = setTimeout(function(){
                        processSearch();
                    }, 500);
                }
            });
        }

        $(".download-card-load-more .button").on('click', function() {
            // Show the next content, until the next button "Load more"
            var $downloadContent = $(this).parents(".accordion-content").next();
            while ($downloadContent.length) {
                // Show this download card
                $downloadContent.removeClass("download-card-hidden");
                // is there a button "Load more" inside this element ?
                if ($downloadContent.children(".download-card-load-more").length) {
                    // Yes, then stop the loop ...
                    break;
                }
                $downloadContent = $downloadContent.next();
            }

            // Hide this button
            $(this).parents(".download-card-load-more").addClass("download-card-load-more-hidden");
        });
    });
})(jQuery);